export default function BookingSection() {
  return (
    <section id="booking" className="py-28 bg-[#050810]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="max-w-2xl">
          {/* Left: Info */}
          <div>
            <span className="text-[#d4af37] text-xs font-semibold tracking-widest uppercase mb-4 block">
              Free Strategy Call
            </span>
            <h2 className="text-4xl md:text-5xl font-black text-white leading-tight mb-6">
              Book a Call<br />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#d4af37] to-[#f0d060]">
                With Our Team
              </span>
            </h2>
            <p className="text-white/50 text-base leading-relaxed mb-10">
              Pick a time that works for you and we&apos;ll hop on a free strategy call. No pressure, no pitch — just honest advice on how to grow your online presence and bring in more clients.
            </p>

            {/* What to expect */}
            <div className="space-y-4 mb-10">
              {[
                {
                  icon: "ri-bar-chart-grouped-line",
                  title: "Growth Strategy",
                  desc: "Tailored recommendations to increase leads and conversions.",
                },
                {
                  icon: "ri-price-tag-3-line",
                  title: "Transparent Pricing",
                  desc: "Clear scope and cost — no surprises, no hidden fees.",
                },
              ].map((item) => (
                <div key={item.title} className="flex items-start gap-4">
                  <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-[#d4af37]/10 border border-[#d4af37]/20 flex-shrink-0 mt-0.5">
                    <i className={`${item.icon} text-[#d4af37] text-base`}></i>
                  </div>
                  <div>
                    <div className="text-white text-sm font-semibold mb-0.5">{item.title}</div>
                    <div className="text-white/40 text-sm">{item.desc}</div>
                  </div>
                </div>
              ))}
            </div>

            {/* Duration badge */}
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-[#d4af37]/20 bg-[#d4af37]/5">
              <i className="ri-time-line text-[#d4af37] text-sm"></i>
              <span className="text-white/60 text-xs">100% free &bull; No commitment</span>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}
